import React, { Component } from "react";
import Modal from "react-modal";
// import { Table as MaterialTable } from "@material-ui/core";
import config from "@config";
import apiEndpoints from "@store/apiEndpoints";
import errorFunctions from "@store/errorFunctions";
import utilityFunctions from "@store/utilityFunctions";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Link } from "react-router-dom";
import { createBrowserHistory } from "history";
import { TablePagination } from "@material-ui/core";
import LoadingPage from "@components/Loading/Loading";
import Select from "react-select";

const countryOptions = [
  { value: 1, label: "Australia (AU)" },
  { value: 2, label: "New Zealand (NZ)" },
];
export default class ServiceCenterAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sellers: [],
      filteredSellers: [],
      filteredStores: [],
      selectedSeller: null,
      sellerId: null,
      newSeller: null,
      stores: [],
      selectedStore: null,
      store: null,
      storeId: null,
      showSellerAdd: false,
      showStoreAdd: false,
      showSellerEdit: false,
      showStoreEdit: false,
      showDeleteSeller: false,
      showDeleteStore: false,
      deleteSeller: null,
      deleteStore: null,
      searchSeller: null,
      countryValue: [],
      role: this.props.userInfo.user.role,
      rowsPerPage: 15,
      page: 0,
      rowsPerPageSeller: 50,
      pageSeller: 0,
      totalCountSeller: 0,
      userBrands: this.props.userInfo?.user?.brands || [],
      isCountryAU: config.country === "AU",
      hasFetchedSellers: false, // Add flag to track initial fetch
      sellerRowsPerPage: 50,
      sellerPage: 0,
      sellerTotalCount: 0,
      isFetchingSeller: false,
      isFetchingStore: false,
    };
    // Add debounce timers
    this.sellerSearchTimer = null;
    this.storeSearchTimer = null;
  }

  componentDidMount() {
    if (
      ["Commercial Admin", "Commercial Staff"].includes(
        this.props.userInfo.user.role,
      )
    ) {
      this.retrieveStore({ page: 1, rowsPerPage: 15 });
    } else {
      this.retrieveSeller({ page: 1, rowsPerPage: 15 });
    }
  }

  componentDidUpdate(prevProps) {
    // Check if selectedbrandID has changed
    if (prevProps.selectedbrandID !== this.props.selectedbrandID) {
      // Cancel any pending requests
      if (this.sellerSearchTimer) clearTimeout(this.sellerSearchTimer);
      if (this.storeSearchTimer) clearTimeout(this.storeSearchTimer);

      if (
        ["Commercial Admin", "Commercial Staff"].includes(
          this.props.userInfo.user.role,
        )
      ) {
        this.setState({ page: 0 }, () => {
          this.retrieveStore({ page: 1, rowsPerPage: this.state.rowsPerPage });
        });
      } else {
        this.setState({ pageSeller: 0 }, () => {
          this.retrieveSeller({
            page: 1,
            rowsPerPage: this.state.rowsPerPageSeller,
          });
        });
      }
    }
  }

  componentWillUnmount() {
    // Clean up timers
    if (this.sellerSearchTimer) clearTimeout(this.sellerSearchTimer);
    if (this.storeSearchTimer) clearTimeout(this.storeSearchTimer);
  }

  retrieveSeller({ page, rowsPerPage, q } = {}) {
    // Prevent duplicate calls
    if (this.state.isFetchingSeller) {
      return;
    }

    this.setState({
      isLoading: true,
      isFetchingSeller: true,
    });

    this.setState({
      isLoading: true,
    });

    const userBrands = this.props.userInfo?.user?.brands || [];
    const country = config.country;

    // Filter brands by country if country exists
    const filteredBrands = country
      ? userBrands.filter((brand) => brand.country === country)
      : userBrands;

    // Get all brand IDs
    const brandIds = filteredBrands.map((brand) => brand.id).join(",");

    // Construct URL with brand IDs or selected brand
    const brandParam = this.props.selectedbrandID
      ? `?brandId=${this.props.selectedbrandID}`
      : brandIds
        ? `?brandId=${brandIds}`
        : "";

    // Add pagination parameters
    const currentPage = page || this.state.pageSeller + 1;
    const limit = rowsPerPage || this.state.rowsPerPageSeller;

    let queryStr = brandParam;
    queryStr += queryStr.includes("?") ? "&" : "?";
    queryStr += `page=${currentPage}&limit=${limit}&pagination=true`;

    // Add search query if exists
    if (q) {
      queryStr += `&search=${encodeURIComponent(q)}`;
    }

    const queryParams = {};
    // Add pagination parameters
    queryParams.page = page || this.state.sellerPage + 1;
    queryParams.page_size = rowsPerPage || this.state.sellerRowsPerPage;
    queryParams.pagination = true;

    if (q) {
      queryParams.search = q;
    }

    this.props
      .protectedFetch(
        apiEndpoints.seller.list() + queryStr,
        "GET",
        null,
        errorFunctions.checkResponseThenJson,
      )
      .then((res) => {
        const sellerData = res.results || [];
        const firstSeller = sellerData[0];
        const shouldSelectFirstSeller =
          !this.state.selectedSeller && firstSeller;

        this.setState({
          sellers: sellerData,
          filteredSellers: sellerData,
          sellerTotalCount: res.count || 0,
          isLoading: false,
          isFetchingSeller: false,
          ...(shouldSelectFirstSeller && {
            seller: firstSeller.name,
            sellerId: firstSeller.id,
            selectedSeller: firstSeller,
            brandValue:
              firstSeller.brand?.map((b) => ({ label: b.name, value: b.id })) ||
              [],
          }),
          hasFetchedSellers: true, // Set flag after first fetch
          seller: !this.state.seller && sellerData[0]?.name,
          sellerId: !this.state.seller && sellerData[0]?.id,
          selectedSeller: !this.state.selectedSeller && sellerData[0],
          brandValue:
            !this.state.brandValue?.length && sellerData[0]?.brand
              ? sellerData[0].brand.map((b) => ({ label: b.name, value: b.id }))
              : this.state.brandValue,
        });

        // Only fetch store if we just selected first seller
        if (shouldSelectFirstSeller) {
          this.retrieveStore({ seller: firstSeller.id });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ isLoading: false, isFetchingSeller: false });
      });
  }

  retrieveStore({ seller, page, rowsPerPage, q } = {}) {
    // Prevent duplicate calls
    if (this.state.isFetchingStore) {
      return;
    }

    this.setState({
      isLoading: true,
      isFetchingStore: true,
    });

    const fetchUrl = seller
      ? apiEndpoints.seller.storeLocations(seller)
      : apiEndpoints.storeLocations.list();

    // Build query parameters object
    const queryParams = {};

    queryParams.country = config.country;

    queryParams.country = config.country;

    // Always use pagination
    queryParams.page = page || this.state.page + 1; // API pages usually start at 1
    queryParams.limit = rowsPerPage || this.state.rowsPerPage;
    queryParams.pagination = true;

    if (q) {
      queryParams.q = q;
    }

    utilityFunctions
      .protectedFetch(
        fetchUrl,
        "GET",
        queryParams,
        errorFunctions.checkResponseThenJson,
      )
      .then((res) => {
        const storeData = res.results || [];
        this.setState({
          stores: storeData,
          filteredStores: storeData,
          totalCount: res.count || 0, // Store total count from API
          isLoading: false,
          isFetchingStore: false,
        });
      })
      .catch((err) => {
        this.setState({
          isLoading: false,
          isFetchingStore: false,
        });
        console.log(err);
      });
  }
  // deleteStore() {

  deleteSeller = () => {
    const token = utilityFunctions.getAccessToken();
    const options = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    };

    this.setState({ loading: true, showDeleteSeller: false });
    fetch(apiEndpoints.seller.detail(this.state.selectedSeller.id), options)
      .then((resp) => {
        if (resp.status === 403)
          alert(
            "Cannot delete store. Device is already registered by at least one user(s)",
          );
        else if (resp.status === 204) alert("Delete success");
        else alert("status:" + resp.status);

        this.setState({
          showDeleteSeller: false,
          deleteSeller: null,
          loading: false,
          isLoading: false,
          selectedSeller: null,
          seller: null,
          stores: [],
          filteredStores: [],
        });
        // Only fetch seller list once
        this.retrieveSeller();
      })
      .catch((err) => {
        alert(err);
        this.setState({ showDeleteSeller: false, loading: false });
      });
  };
  updateSeller(e) {
    e.preventDefault();
    this.setState({
      isLoading: true,
    });
    const payload = {
      name: this.state.newSeller,
      country: this.state.countryValue?.map((item) => item.value) ?? [],
    };

    // if (this.state.isCountryAU) {
      payload.brand = this.state.brandValue?.map((item) => item.value) ?? [];
    // }

    if (this.state.cin7Name) {
      payload.cin7_name = this.state.cin7Name;
    }

    utilityFunctions
      .protectedFetch(
        apiEndpoints.seller.detail(this.state.selectedSeller.id),
        "PATCH",
        payload,
        errorFunctions.checkResponseThenJson,
      )
      .then((res) => {
        this.setState({
          isLoading: false,
          seller: res.name,
          selectedSeller: res,
          showSellerEdit: false,
        });
        // Only fetch seller list once
        this.retrieveSeller();
        // Store will be updated when seller list is fetched
      })
      .catch((err) => {
        this.setState({
          isLoading: false,
        });
        console.log(err);
      });
  }
  addSeller(e) {
    e.preventDefault();
    this.setState({
      isLoading: true,
    });
    const payload = {
      name: this.state.newSeller,
      country: this.state.countryValue?.map((item) => item.value) ?? [],
      brand_id: this.props.selectedbrandID,
    };

    if (
      payload?.name == null ||
      payload?.name === "" ||
      payload?.name?.length === 0
    ) {
      this.setState({
        isLoading: false,
        errorMessage: "Store name is required",
      });
      return;
    }

    if (this.state.cin7Name) {
      payload.cin7_name = this.state.cin7Name;
    }

    // if (this.state.isCountryAU) {
      payload.brand =
        this.state.userBrands
          ?.filter((item) => item.country === config.country)
          .map((item) => item.id) ?? [];
    // }

    utilityFunctions
      .protectedFetch(
        apiEndpoints.seller.create(),
        "POST",
        payload,
        errorFunctions.checkResponseThenJson,
      )
      .then((res) => {
        this.setState({
          isLoading: false,
          seller: res.name,
          showSellerAdd: false,
          newSeller: null,
        });
        // Only fetch seller list once
        this.retrieveSeller();
      })
      .catch((err) => {
        // alert("Store with this name already exists.");
        console.log(err);
        this.setState({
          isLoading: false,
          errorMessage:
            err.message ||
            "Error adding store" ||
            "Store with this name already exists.",
        });
      });
  }

  updateStore(e) {
    e.preventDefault();
    this.setState({
      isLoading: true,
    });
    let payload = {
      name: this.state.newStore,
      seller: this.state.selectedSeller.id,
    };

    if (this.state.cin7Name) {
      payload = {
        ...payload,
        cin7_name: this.state.cin7Name,
      };
    }

    if (this.state.brandValueStore.length > 0) {
      payload = {
        ...payload,
        brand: this.state.brandValueStore?.map((item) => item.value) ?? [],
      };
    }

    utilityFunctions
      .protectedFetch(
        apiEndpoints.seller.storeLocation(this.state.selectedSeller.id, this.state.selectedStore.id),
        "PATCH",
        payload,
        errorFunctions.checkResponseThenJson,
      )
      .then((res) => {
        console.log("update ", res);
        this.setState({
          isLoading: false,
          showStoreEdit: false,
        });
        // Only fetch store list once
        this.retrieveStore({ seller: this.state.selectedSeller.id });
      })
      .catch((err) => {
        this.setState({
          isLoading: false,
        });
        console.log(err);
      });
  }
  addStore(e) {
    e.preventDefault();
    this.setState({
      isLoading: true,
    });
    const payload = {
      name: this.state.newStore,
    };

    // if (this.state.isCountryAU) {
      payload.brand =
        this.state.userBrands
          ?.filter((item) => item.country === config.country)
          .map((item) => item.id) ?? [];
    // }

    utilityFunctions
      .protectedFetch(
        apiEndpoints.seller.addStoreLocation(this.state.sellerId),
        "POST",
        payload,
        errorFunctions.checkResponseThenJson,
      )
      .then((res) => {
        this.setState({
          isLoading: false,
          store: res.name,
          newStore: null,
          showStoreAdd: false,
          errorMessage: null,
          cin7Name: "",
        });
        // Only fetch store list once
        this.retrieveStore({ seller: this.state.sellerId });
      })
      .catch((err) => {
        console.log(err);
        alert(err);
        this.setState({
          isLoading: true,
          errorMessage: err.message || "Error adding store",
        });
      });
    this.setState({
      showStoreAdd: false,
    });
  }

  deleteStore = () => {
    const token = utilityFunctions.getAccessToken();
    const options = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    };

    this.setState({ loading: true, showDeleteStore: false });

    fetch(apiEndpoints.seller.storeLocation(this.state.selectedSeller.id, this.state.selectedStore.id), options)
      .then((resp) => {
        if (resp.status === 403)
          alert(
            "Cannot delete store. Device is already registered by at least one user(s)",
          );
        else if (resp.status === 204) alert("Delete success");
        else alert("status:" + resp.status);

        this.setState({
          showDeleteStore: false,
          deleteStore: null,
          isLoading: false,
          loading: false,
        });
        // Only fetch store list once
        this.retrieveStore({ seller: this.state.selectedSeller.id });
      })
      .catch((err) => {
        alert(err);
        this.setState({
          showDeleteStore: false,
          isLoading: false,
          loading: false,
        });
      });
  };

  handleSellerClick(seller) {
    // Only fetch if different seller is selected
    if (this.state.selectedSeller?.id === seller.id) {
      return;
    }

    this.setState({
      seller: seller.name,
      selectedSeller: seller,
      sellerId: seller.id,
      deleteItem: seller,
      brandValue:
        seller.brand?.map((b) => ({ label: b.name, value: b.id })) ?? [],
      page: 0, // Reset store page
    });

    // Fetch store locations for the selected seller
    this.retrieveStore({
      seller: seller.id,
      page: 1,
      rowsPerPage: this.state.rowsPerPage,
    });
  }

  handleStoreRowClick(store) {
    this.setState({ store: store, deleteItem: store });
    // this.retrieveStore(seller);
  }
  handleStoreLocationClick = (id) => {
    const history = createBrowserHistory({ forceRefresh: true });
    history.push(`/commercial/${id}`);
    // alert("row");
  };

  handleEditSeller(seller) {
    this.setState({ seller: seller, showSeller: true });
  }
  handleDeleteSeller(selectedSeller) {
    this.setState({
      selectedSeller: selectedSeller,
      showDeleteSeller: true,
      deleteSeller: selectedSeller,
    });
  }
  handleDeleteStore(store) {
    this.setState({
      selectedStore: store,
      showDeleteStore: true,
      deleteStore: store,
    });
  }

  handleInputChange = (e) => {
    const { id, value } = e.target;
    this.setState({
      [id]: value,
    });
  };

  handleSearchSeller = (e) => {
    this.handleInputChange(e);
    const filter = e.target.value;

    // Clear existing timer
    if (this.sellerSearchTimer) {
      clearTimeout(this.sellerSearchTimer);
    }

    // Set new timer for debounced search
    this.sellerSearchTimer = setTimeout(() => {
      this.setState({ sellerPage: 0 }, () => {
        if (filter.length > 2 || filter.length === 0) {
          this.retrieveSeller({
            page: 1,
            rowsPerPage: this.state.sellerRowsPerPage,
            q: filter || undefined,
          });
        }
      });
    }, 500); // 500ms debounce
  };

  handleSearchStore = (e) => {
    this.handleInputChange(e);
    const filter = e.target.value;

    // Clear existing timer
    if (this.storeSearchTimer) {
      clearTimeout(this.storeSearchTimer);
    }

    // Set new timer for debounced search
    this.storeSearchTimer = setTimeout(() => {
      this.setState({ page: 0 }, () => {
        if (filter.length > 2 || filter.length === 0) {
          this.retrieveStore({
            seller: this.state.selectedSeller?.id,
            page: 1,
            rowsPerPage: this.state.rowsPerPage,
            q: filter || undefined,
          });
        }
      });
    }, 500); // 500ms debounce
  };

  handleAddSeller = (e) => {
    if (this.state.newSeller) {
      if (this.state.selectedSeller) this.updateSeller(e);
      else this.addSeller(e);
    } else alert("Store can't be empty");
  };

  handleDeleteConfirmation = (e) => {
    if (this.state.deleteSeller) this.deleteSeller(e);
    else if (this.state.deleteStore) this.deleteStore(e);
  };

  handleChangePage = (event, newPage) => {
    this.setState(
      {
        page: newPage,
      },
      () => {
        // Call API with new page
        this.retrieveStore({
          seller: this.state.selectedSeller?.id,
          page: newPage + 1, // API pages start at 1
          rowsPerPage: this.state.rowsPerPage,
          q: this.state.searchStore,
        });
      },
    );
  };
  handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    this.setState(
      {
        rowsPerPage: newRowsPerPage,
        page: 0,
      },
      () => {
        // Call API with new rows per page
        this.retrieveStore({
          seller: this.state.selectedSeller?.id,
          page: 1,
          rowsPerPage: newRowsPerPage,
          q: this.state.searchStore,
        });
      },
    );
  };

  handleSellerChangePage = (event, newPage) => {
    this.setState(
      {
        sellerPage: newPage,
      },
      () => {
        this.retrieveSeller({
          page: newPage + 1,
          rowsPerPage: this.state.sellerRowsPerPage,
          q: this.state.searchSeller,
        });
      },
    );
  };

  handleSellerChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    this.setState(
      {
        sellerRowsPerPage: newRowsPerPage,
        sellerPage: 0,
      },
      () => {
        this.retrieveSeller({
          page: 1,
          rowsPerPage: newRowsPerPage,
          q: this.state.searchSeller,
        });
      },
    );
  };

  // Add pagination handlers for sellers
  handleChangePageSeller = (event, newPage) => {
    this.setState(
      {
        pageSeller: newPage,
      },
      () => {
        this.retrieveSeller({
          page: newPage + 1,
          rowsPerPage: this.state.rowsPerPageSeller,
          q: this.state.searchSeller,
        });
      },
    );
  };

  handleChangeRowsPerPageSeller = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    this.setState(
      {
        rowsPerPageSeller: newRowsPerPage,
        pageSeller: 0,
      },
      () => {
        this.retrieveSeller({
          page: 1,
          rowsPerPage: newRowsPerPage,
          q: this.state.searchSeller,
        });
      },
    );
  };

  render() {
    // const rows = this.state.filteredStores || [];
    const showStoreLocations =
      this.state.selectedSeller ||
      ["Commercial Admin", "Commercial Staff"].includes(
        this.props.userInfo.user.role,
      );

    return (
      <div className={"page"}>
        {(this.state.isLoading || this.state.loading) && <LoadingPage />}
        <div
          style={{
            width: "100px",
            borderBottom: "1px solid black",
            textAlign: "center",
          }}
        >
          <h5>Stores</h5>
        </div>
        <div className="d-flex">
          {["Admin", "Staff"].includes(this.props.userInfo.user.role) && (
            <div className="col">
              <div className="mt-1">
                <div className="input-group my-2">
                  <input
                    type="text"
                    placeholder="Search stores"
                    data-testid={"searchStore"}
                    id="searchSeller"
                    value={this.state.searchSeller}
                    className="form-control"
                    onChange={(e) => this.handleSearchSeller(e)}
                  />
                  <div className="input-group-prepend">
                    <span className="form-control ">
                      <i className="fa fa-search form-control-icon"></i>
                    </span>
                  </div>
                </div>

                <TableContainer sx={{ maxHeight: 800, overflowX: "auto" }}>
                  <Table
                    sx={{ minWidth: 400 }}
                    aria-labelledby="tableTitle"
                    size={"small"}
                    aria-label="enhanced table"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>Store</TableCell>
                        <TableCell>Country</TableCell>
                        <TableCell className="text-end">
                          <button
                            className="k-btn k-btn-primary k-btn-sm"
                            onClick={() =>
                              this.setState({
                                seller: null,
                                newSeller: null,
                                showSellerAdd: true,
                                countryValue: [],
                                brandValue: [],
                                cin7Name: "",
                              })
                            }
                          >
                            Add
                          </button>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {this.state.filteredSellers?.map((s, i) => {
                        return (
                          <TableRow
                            key={i}
                            className={
                              this.state.selectedSeller?.name === s.name &&
                              "font-weight-bold bg-light"
                            }
                          >
                            <TableCell
                              style={{
                                wordWrap: "break-word",
                                cursor: "pointer",
                              }}
                              onClick={() => this.handleSellerClick(s)}
                            >
                              {s.name}
                            </TableCell>
                            <TableCell
                              style={{
                                wordWrap: "break-word",
                                cursor: "pointer",
                              }}
                              onClick={() => this.handleSellerClick(s)}
                            >
                              {s.country.length > 1
                                ? s.country.join(", ")
                                : s.country}
                            </TableCell>
                            <TableCell
                              style={{
                                width: "200px",
                                wordWrap: "break-word",
                              }}
                            >
                              <div>
                                <button
                                  className={
                                    "btn btn-outline-primary btn-sm mr-1 "
                                  }
                                  onClick={() => {
                                    this.setState({
                                      seller: s.name,
                                      selectedSeller: s,
                                      newSeller: s.name,
                                      brandValue:
                                        s.brand?.map((b) => ({
                                          label: b.name,
                                          value: b.id,
                                        })) ?? [],
                                      sellerId: s.id,
                                      countryValue: countryOptions.filter((c) =>
                                        s.country.some((code) =>
                                          c.label.includes(code),
                                        ),
                                      ),
                                      showSellerEdit: true,
                                      cin7Name: s.cin7_name,
                                    });
                                  }}
                                >
                                  Edit
                                </button>
                                {/* if delete functionality is needed in the future, uncomment below and add deleteSeller function */}
                                {/* <button
                                  className={"btn btn-outline-danger btn-sm "}
                                  onClick={() => this.handleDeleteSeller(s)}
                                >
                                  Delete
                                </button> */}
                              </div>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 15, 25, 50, 100]}
                  component="div"
                  count={this.state.sellerTotalCount || 0}
                  rowsPerPage={this.state.sellerRowsPerPage}
                  page={this.state.sellerPage}
                  onPageChange={this.handleSellerChangePage}
                  onRowsPerPageChange={this.handleSellerChangeRowsPerPage}
                />
              </div>
            </div>
          )}
          <div className="col">
            <div className="mt-1">
              <div className="input-group my-2">
                <input
                  type="text"
                  placeholder="Search Store Location"
                  data-testid={"refund-amount"}
                  id="searchStore"
                  value={this.state.searchStore}
                  className="form-control"
                  // style={{ height: "100%" }}
                  onChange={(e) => this.handleSearchStore(e)}
                />
                <div className="input-group-prepend">
                  <span className="form-control ">
                    <i className="fa fa-search form-control-icon"></i>
                  </span>
                </div>
              </div>
              <TableContainer sx={{ maxHeight: 600, overflowX: "auto" }}>
                <Table
                  sx={{ minWidth: 600 }}
                  aria-labelledby="tableTitle"
                  size={"small"}
                  aria-label="enhanced table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ width: "300px" }}>
                        Store Location
                      </TableCell>
                      <TableCell
                        style={{
                          width: "100px",
                          wordWrap: "break-word",
                          cursor: "pointer",
                        }}
                      >
                        Commercial Users
                      </TableCell>
                      <TableCell sx={{ width: "60px" }}>
                        Tickets Numbers
                      </TableCell>
                      <TableCell className="text-end">
                        {showStoreLocations &&
                          ["Admin", "Staff"].includes(
                            this.props.userInfo.user.role,
                          ) && (
                            <button
                              className="k-btn k-btn-primary k-btn-sm"
                              onClick={() =>
                                this.setState({
                                  store: null,
                                  newStore: null,
                                  showStoreAdd: true,
                                  brandValueStore: [],
                                })
                              }
                            >
                              Add
                            </button>
                          )}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.filteredStores.length > 0 &&
                    showStoreLocations ? (
                      this.state.filteredStores.map((s, i) => {
                        return (
                          <TableRow
                            key={i}
                            className={
                              this.state.store === s.name &&
                              "font-weight-bold  bg-light"
                            }
                          >
                            <TableCell
                              style={{
                                width: "300px",
                              }}
                            >
                              {s.name}
                            </TableCell>
                            <TableCell
                              style={{
                                wordWrap: "break-word",
                              }}
                            >
                              {s.commercial_user_count || "0"}
                            </TableCell>
                            <TableCell
                              style={{
                                wordWrap: "break-word",
                              }}
                            >
                              <Link to={"/tickets?store_location=" + s.id}>
                                {s.ticket_count}
                              </Link>
                            </TableCell>
                            <TableCell>
                              {["Admin", "Staff"].includes(
                                this.props.userInfo.user.role,
                              ) && (
                                <div>
                                  <button
                                    className={
                                      "btn btn-outline-primary btn-sm mr-1 "
                                    }
                                    onClick={() => {
                                      this.setState({
                                        store: s.name,
                                        storeId: s.id,
                                        newStore: s.name,
                                        brandValueStore:
                                          s.brand?.map((b) => ({
                                            label: b.name,
                                            value: b.id,
                                          })) ?? [],
                                        cin7Name: s.cin7_name,
                                        showStoreEdit: true,
                                        selectedStore: s,
                                      });
                                    }}
                                  >
                                    Edit
                                  </button>
                                  {/* if delete functionality is needed in the future, uncomment below and add deleteSeller function */}
                                  {/* <button
                                    className={"btn btn-outline-danger btn-sm "}
                                    onClick={() => this.handleDeleteStore(s)}
                                  >
                                    Delete
                                  </button> */}
                                </div>
                              )}
                            </TableCell>
                          </TableRow>
                        );
                      })
                    ) : (
                      <TableRow>
                        {!showStoreLocations ? (
                          <TableCell>
                            Please select a store to see store locations
                          </TableCell>
                        ) : (
                          <TableCell>No data</TableCell>
                        )}
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 15, 25, 50, 100]}
                component="div"
                count={this.state.totalCount || 0}
                rowsPerPage={this.state.rowsPerPage}
                page={this.state.page}
                onPageChange={this.handleChangePage}
                onRowsPerPageChange={this.handleChangeRowsPerPage}
              />
            </div>
          </div>
        </div>
        <Modal
          isOpen={this.state.showSellerEdit || this.state.showSellerAdd}
          contentLabel={"Set as Out of Warranty"}
          className={"confirm-modal "}
        >
          <div className="card">
            <div className="card-header">
              {this.state.showSellerEdit ? "Edit Store" : "Add Store"}
            </div>
            <div className={"card-body"}>
              {this.state.showSellerEdit && (
                <div className="col text-start mt-3 mb-3">
                  <label className={"single-warranty-details-label"}>
                    Brand*
                  </label>
                  <Select
                    id={"brand-id"}
                    isMulti
                    data-testid="assign-to-select"
                    value={this.state.brandValue}
                    options={this.state.userBrands
                      .filter((e) => e.country === config.country)
                      .map((b) => ({ label: b.name, value: b.id }))}
                    onChange={(obj) => this.setState({ brandValue: obj })}
                  />
                </div>
              )}
              <div className="text-start m-3">
                <label
                  className={"single-warranty-details-label "}
                  htmlFor="deviceName"
                >
                  Store Name*
                </label>
                <input
                  type="text"
                  required
                  data-testid={"refund-amount"}
                  id="newSeller"
                  value={this.state.newSeller}
                  className="form-control"
                  style={{ height: "100%" }}
                  onChange={(e) => this.handleInputChange(e)}
                />
              </div>
              <div className="text-start m-3">
                <label
                  className={"single-warranty-details-label "}
                  htmlFor="cin7Name"
                >
                  Cin7 Name
                </label>
                <input
                  type="text"
                  required
                  data-testid={"refund-amount"}
                  id="cin7Name"
                  value={this.state.cin7Name}
                  className="form-control"
                  style={{ height: "100%" }}
                  onChange={(e) => this.handleInputChange(e)}
                />
              </div>
              <div className="col text-start mt-3 mb-3">
                <label className={"single-warranty-details-label"}>
                  Country
                </label>
                <Select
                  id={"country-id"}
                  isMulti
                  data-testid="assign-to-select"
                  value={this.state.countryValue}
                  options={countryOptions}
                  onChange={(obj) => this.setState({ countryValue: obj })}
                />
              </div>
              {!this.state.showSellerEdit && this.state.errorMessage && (
                <div
                  className="text-danger text-start m-3"
                  style={{ fontSize: "10px" }}
                >
                  {this.state.errorMessage}
                </div>
              )}
              <button
                data-testid="confirm-status-ticket"
                type="button"
                className={"btn btn-outline-primary mr-3"}
                onClick={(e) =>
                  this.state.showSellerEdit
                    ? this.updateSeller(e)
                    : this.addSeller(e)
                }
              >
                Submit
              </button>
              <button
                type={"button"}
                className={"btn btn-outline-secondary"}
                onClick={() =>
                  this.setState(
                    this.state.showSellerEdit
                      ? { showSellerEdit: false }
                      : { showSellerAdd: false },
                  )
                }
              >
                Cancel
              </button>
            </div>
          </div>
        </Modal>
        <Modal
          isOpen={this.state.showStoreAdd || this.state.showStoreEdit}
          contentLabel={"Set as Out of Warranty"}
          className={"confirm-modal "}
        >
          <div className="card">
            <div className="card-header">
              {this.state.showStoreEdit
                ? "Edit Store Location"
                : "Add Store Location"}
            </div>
            <div className={"card-body"}>
              {this.state.showStoreEdit && (
                <div className="text-start m-3">
                  <label className={"single-warranty-details-label"}>
                    Brand*
                  </label>
                  <Select
                    id={"brand-id"}
                    isMulti
                    data-testid="assign-to-select"
                    value={this.state.brandValueStore}
                    options={this.state.userBrands
                      .filter((e) => e.country === config.country)
                      .map((b) => ({ label: b.name, value: b.id }))}
                    onChange={(obj) => this.setState({ brandValueStore: obj })}
                  />
                </div>
              )}
              <div className="text-start m-3">
                <label
                  className={"single-warranty-details-label "}
                  htmlFor="deviceName"
                >
                  Store Location Name*
                </label>
                <input
                  type="text"
                  required
                  data-testid={"refund-amount"}
                  id="newStore"
                  value={this.state.newStore}
                  className="form-control"
                  style={{ height: "100%" }}
                  onChange={(e) => this.handleInputChange(e)}
                />
              </div>
              {this.state.showStoreEdit && (
                <div className="text-start m-3">
                  <label
                    className={"single-warranty-details-label "}
                    htmlFor="cin7Name"
                  >
                    Cin7 Name
                  </label>
                  <input
                    type="text"
                    required
                    data-testid={"refund-amount"}
                    id="cin7Name"
                    value={this.state.cin7Name}
                    className="form-control"
                    style={{ height: "100%" }}
                    onChange={(e) => this.handleInputChange(e)}
                  />
                </div>
              )}
              <button
                data-testid="confirm-status-ticket"
                type="button"
                className={"btn btn-outline-primary mr-3"}
                onClick={(e) =>
                  this.state.showStoreEdit
                    ? this.updateStore(e)
                    : this.addStore(e)
                }
              >
                Submit
              </button>
              <button
                type={"button"}
                className={"btn btn-outline-secondary"}
                onClick={() =>
                  this.setState(
                    this.state.showStoreEdit
                      ? { showStoreEdit: false, cin7Name: "" }
                      : { showStoreAdd: false, cin7Name: "" },
                  )
                }
              >
                Cancel
              </button>
            </div>
          </div>
        </Modal>
        <Modal
          isOpen={this.state.showDeleteSeller}
          contentLabel={"Set as Out of Warranty"}
          className={"confirm-modal "}
        >
          <div className="card">
            <div className="card-header">Delete Confirmation</div>
            <div className={"card-body"}>
              <div className="text-start m-3">{`Are you sure want to delete ${this.state.selectedSeller?.name}?`}</div>
              <button
                data-testid="confirm-status-ticket"
                type="button"
                className={"btn btn-outline-primary mr-3"}
                onClick={() => this.deleteSeller()}
              >
                Delete
              </button>
              <button
                type={"button"}
                className={"btn btn-outline-secondary"}
                onClick={() => this.setState({ showDeleteSeller: false })}
              >
                Cancel
              </button>
            </div>
          </div>
        </Modal>
        <Modal
          isOpen={this.state.showDeleteStore}
          contentLabel={"Set as Out of Warranty"}
          className={"confirm-modal "}
        >
          <div className="card">
            <div className="card-header">Delete Confirmation</div>
            <div className={"card-body"}>
              <div className="text-start m-3">{`Are you sure want to delete ${this.state.selectedStore?.name}?`}</div>
              <button
                data-testid="confirm-status-ticket"
                type="button"
                className={"btn btn-outline-primary mr-3"}
                onClick={() => this.deleteStore()}
              >
                Delete
              </button>
              <button
                type={"button"}
                className={"btn btn-outline-secondary"}
                onClick={() => this.setState({ showDeleteStore: false })}
              >
                Cancel
              </button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
